import { ReactNode } from 'react';

interface EmptyStateProps {
  title: string;
  description?: ReactNode;
  action?: ReactNode;
}

export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 px-6 py-10 text-center text-slate-500">
      <div className="text-sm font-medium text-slate-700">{title}</div>
      {description ? (
        <p className="max-w-md text-xs text-slate-500">{description}</p>
      ) : null}
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}

export function ErrorState({
  title,
  description,
  retry,
}: {
  title: string;
  description?: ReactNode;
  retry?: () => void;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-rose-200 bg-rose-50/70 px-6 py-8 text-center">
      <div className="text-sm font-medium text-rose-700">{title}</div>
      {description ? (
        <p className="max-w-md text-xs text-rose-600">{description}</p>
      ) : null}
      {retry ? (
        <button
          type="button"
          onClick={retry}
          className="rounded-md border border-rose-200 bg-white px-3 py-1.5 text-xs font-medium text-rose-700 hover:bg-rose-50"
        >
          重试
        </button>
      ) : null}
    </div>
  );
}

export function LoadingState({ label = '加载中…' }: { label?: string }) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 px-6 py-10 text-slate-400">
      <div
        aria-hidden
        className="h-6 w-6 animate-spin rounded-full border-2 border-slate-200 border-t-brand-500"
      />
      <span className="text-xs">{label}</span>
    </div>
  );
}
